/**
 * Utilidades para el módulo de Login
 */

/**
 * Formatea el mensaje de error basado en el tipo de error recibido
 * @param {Error} err - Error capturado en el catch
 * @returns {string} Mensaje de error formateado para el usuario
 */
export const formatLoginError = (err) => {
  let msg = "No se pudo iniciar sesión. Verifica tus datos.";

  if (err.code === "ERR_NETWORK" || !err.response) {
    msg = "Error de conexión. Verifica que el servidor esté activo.";
  } else if (err.response?.status === 401) {
    msg = "Usuario o contraseña incorrectos.";
  } else if (err.response?.data?.message) {
    msg = err.response.data.message;
  }

  return msg;
};

